module.exports = __webpack_public_path__ + "img/logo.9834a042.jpg";